import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { X, Plus, RefreshCw, Search, Trash2, TrendingUp } from "lucide-react";
import { Loading } from "notiflix";
import Spinner from "../../Components/Loading/Spinner";
import {
  CreateEventByAdmin,
  DeleteFeaturedEvent,
  GetAllFeaturedEvents,
} from "../../redux/actions/Admin/AdminActions";
import { SearchEvents } from "../../redux/actions/Events";
import { ApiMediaURL } from "../../setting/GlobleVariable";
import { getInnerEventFromWrapper } from "../../Components/Home/MarketplaceNewUI/marketplaceHomeFeaturedFromApi";

const inputClass =
  "w-full px-4 py-3 rounded-xl bg-white/[0.04] border border-white/[0.08] text-white text-[14px] placeholder:text-white/25 focus:outline-none focus:ring-2 focus:ring-[#E52324]/30 focus:border-[#E52324]/40 transition-all";

const labelClass =
  "block text-[10px] text-white/40 uppercase tracking-wider mb-1.5";

const thClass =
  "text-left px-5 py-3.5 text-[10px] text-[#E52324] uppercase tracking-widest whitespace-nowrap";

function formatRowId(id) {
  if (!id) return "—";
  const str = String(id);
  return `#${str.length > 6 ? str.slice(0, 6) : str}`;
}

function getEventName(item) {
  const ev = getInnerEventFromWrapper(item);
  const name = ev?.name;
  if (!name) return "—";
  return name.length > 40 ? `${name.slice(0, 40)}…` : name;
}

function getVenue(item) {
  const ev = getInnerEventFromWrapper(item);
  if (!ev) return "—";
  const v = ev.venue;
  if (v && typeof v === "object") {
    return v.name || v.city || "—";
  }
  if (typeof v === "string" && v.trim()) return v;
  return "—";
}

function getCategory(item) {
  const ev = getInnerEventFromWrapper(item);
  if (!ev) return "—";
  const domain = ev.domain?.name || ev.event_category?.name;
  if (domain) return domain;
  const cat = ev.category;
  if (!cat) return "—";
  if (typeof cat === "string") return cat;
  if (typeof cat === "object") return cat.name || cat.slug || "—";
  return "—";
}

function getDescription(item) {
  const text = item?.paragarph || "";
  if (!text) return "—";
  return text.length > 50 ? `${text.slice(0, 50)}…` : text;
}

function TrendingEvent() {
  const [createevent, setcreateevent] = useState(false);
  const [search, setSearch] = useState("");
  const [showDropdown, setDropDown] = useState(null);
  const [Paragraph, setParagraph] = useState("");
  const [image, setImage] = useState(null);
  const [event, setEvent] = useState({});

  const serachevents = useSelector((state) => state.events.serachevents);
  const isLoading = useSelector((state) => state.events.isLoading);
  const adminloading = useSelector((state) => state.Admin.adminloading);
  const featuredEventsRaw = useSelector((state) => state.Admin.featuredEvents);

  const dispatch = useDispatch();
  const UserLocationdata = {};

  const FeaturedEventsdata = useMemo(
    () =>
      featuredEventsRaw?.filter(
        (item) => item?.isFeatured === false && !item?.event?.[0]?._isUserCreated
      ) || [],
    [featuredEventsRaw]
  );

  const resetForm = () => {
    setcreateevent(false);
    setSearch("");
    setParagraph("");
    setImage(null);
    setEvent({});
    setDropDown(null);
  };

  const uploadImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => setImage(file);
      reader.readAsDataURL(file);
    }
  };

  const handleSelectChange = (e) => {
    const filterEvent = serachevents?.filter((item) => item.id == e.target.value);
    setEvent(filterEvent && filterEvent[0]);
  };

  const createeventFunction = async () => {
    if (!Paragraph || !event || !image) {
      return toast.error("Please Enter All fields");
    }
    const formdata = new FormData();
    formdata.append("event", JSON.stringify(event));
    formdata.append("paragarph", Paragraph);
    formdata.append("file", image);
    formdata.append("isFeatured", false);
    await dispatch(CreateEventByAdmin(formdata, "create"));
    resetForm();
  };

  useEffect(() => {
    dispatch(GetAllFeaturedEvents());
  }, [dispatch]);

  useEffect(() => {
    if (adminloading === true) {
      Loading.standard("Loading Please Wait", { svgColor: "#E52324" });
    } else {
      Loading.remove();
    }
  }, [adminloading]);

  const tableHeaders = [
    "ID",
    "Image",
    "Event Name",
    "Description",
    "Venue",
    "Category",
    "isFeatured",
    "Delete",
  ];

  return (
    <div
      className="p-6 sm:p-8"
      style={{ fontFamily: "'Outfit', 'Inter', sans-serif" }}
    >
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <div>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-[#E52324]/15 border border-[#E52324]/20 flex items-center justify-center shrink-0">
              <TrendingUp className="w-5 h-5 text-[#E52324]" strokeWidth={2} />
            </div>
            <div>
              <h1 className="text-[22px] text-white" style={{ fontWeight: 800 }}>
                Trending Events
              </h1>
              <p className="text-white/30 text-[12px] mt-1">
                Manage trending carousel events on the marketplace. (
                {FeaturedEventsdata.length} total)
              </p>
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <button
            type="button"
            onClick={() => dispatch(GetAllFeaturedEvents())}
            className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl border border-white/[0.08] text-white/50 hover:text-white hover:bg-white/[0.03] text-[12px] transition-all"
            style={{ fontWeight: 600 }}
          >
            <RefreshCw className="w-4 h-4" />
            Reload
          </button>
          <button
            type="button"
            onClick={() => {
              resetForm();
              setcreateevent(true);
            }}
            className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-[#E52324] hover:bg-[#d11f20] text-white text-[12px] transition-all shadow-lg shadow-[#E52324]/20"
            style={{ fontWeight: 600 }}
          >
            <Plus className="w-4 h-4" />
            Add New
          </button>
        </div>
      </div>

      <div className="bg-[#0B1120] border border-[#1a1f30] rounded-2xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-[#1a1f30]">
                {tableHeaders.map((h) => (
                  <th key={h} className={thClass} style={{ fontWeight: 700 }}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {FeaturedEventsdata.length > 0 ? (
                FeaturedEventsdata.map((item, index) => {
                  const venue = getVenue(item);
                  const category = getCategory(item);
                  const hasVenue = venue !== "—";
                  const hasCategory = category !== "—";

                  return (
                    <tr
                      key={item?._id || index}
                      className="border-b border-[#1a1f30]/30 last:border-b-0 hover:bg-white/[0.015] transition-colors"
                    >
                      <td
                        className="px-5 py-3.5 text-[12px] text-blue-400 whitespace-nowrap"
                        style={{ fontWeight: 600 }}
                      >
                        {formatRowId(item?._id)}
                      </td>
                      <td className="px-5 py-3.5">
                        {item?.image ? (
                          <img
                            src={`${ApiMediaURL}/${item.image}`}
                            alt=""
                            className="w-10 h-10 rounded-lg object-cover border border-[#1a2744]"
                          />
                        ) : (
                          <span className="text-[11px] text-white/20">—</span>
                        )}
                      </td>
                      <td
                        className="px-5 py-3.5 text-[12px] text-white/80 max-w-[200px] truncate"
                        style={{ fontWeight: 600 }}
                      >
                        {getEventName(item)}
                      </td>
                      <td className="px-5 py-3.5 text-[12px] text-white/40 max-w-[220px] truncate">
                        {getDescription(item)}
                      </td>
                      <td className="px-5 py-3.5 text-[12px] text-white/40 max-w-[160px] truncate">
                        {hasVenue ? venue : "—"}
                      </td>
                      <td className="px-5 py-3.5">
                        {hasCategory ? (
                          <span
                            className="inline-flex px-2 py-0.5 rounded-full text-[9px] uppercase tracking-wider bg-blue-500/15 text-blue-400"
                            style={{ fontWeight: 600 }}
                          >
                            {category}
                          </span>
                        ) : (
                          <span className="text-[12px] text-white/25">—</span>
                        )}
                      </td>
                      <td className="px-5 py-3.5">
                        <span
                          className={`inline-flex px-2 py-0.5 rounded-full text-[9px] uppercase tracking-wider ${
                            item?.isFeatured === true
                              ? "bg-emerald-500/15 text-emerald-400"
                              : "bg-red-500/15 text-red-400"
                          }`}
                          style={{ fontWeight: 600 }}
                        >
                          {item?.isFeatured === true ? "True" : "false"}
                        </span>
                      </td>
                      <td className="px-5 py-3.5">
                        <button
                          type="button"
                          onClick={() => dispatch(DeleteFeaturedEvent(item?._id))}
                          className="w-9 h-9 rounded-lg flex items-center justify-center bg-red-500/10 text-red-400 hover:bg-red-500/20 transition-all"
                          title="Delete"
                        >
                          <Trash2 className="w-4 h-4" />
                        </button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td
                    colSpan={tableHeaders.length}
                    className="px-5 py-16 text-center text-[13px] text-white/30"
                  >
                    No trending events yet. Click &quot;Add New&quot; to create one.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {createevent && (
        <div className="fixed inset-0 z-[99] flex items-center justify-center p-4 bg-black/60">
          <div className="relative w-full max-w-xl max-h-[90vh] overflow-y-auto rounded-2xl bg-[#0B1120] border border-[#1a2744] shadow-xl">
            <div className="sticky top-0 z-10 flex items-center justify-between px-5 py-4 border-b border-[#1a2744] bg-[#0B1120]">
              <h3 className="text-[16px] text-white" style={{ fontWeight: 700 }}>
                New Trending Event
              </h3>
              <button
                type="button"
                onClick={resetForm}
                className="p-1.5 rounded-lg text-white/40 hover:text-white hover:bg-white/[0.05] transition-all"
                aria-label="Close"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            <div className="px-5 py-5 space-y-5">
              <div>
                <label htmlFor="trending-search" className={labelClass}>
                  Search Event By Name
                </label>
                <div className="flex gap-2">
                  <input
                    id="trending-search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && search) {
                        setDropDown(true);
                        dispatch(SearchEvents(search, UserLocationdata));
                      }
                    }}
                    type="text"
                    placeholder="Please Enter Event Name"
                    className={inputClass}
                  />
                  <button
                    type="button"
                    className="inline-flex items-center gap-2 px-4 py-3 rounded-xl bg-[#E52324] hover:bg-[#d11f20] text-white text-[12px] shrink-0 transition-colors"
                    style={{ fontWeight: 600 }}
                    onClick={() => {
                      if (search) {
                        setDropDown(true);
                        dispatch(SearchEvents(search, UserLocationdata));
                      }
                    }}
                  >
                    <Search className="w-4 h-4" />
                    Search
                  </button>
                </div>
              </div>

              {showDropdown && (
                <div>
                  <label htmlFor="trending-event" className={labelClass}>
                    Select Event
                  </label>
                  <select
                    id="trending-event"
                    className={`${inputClass} cursor-pointer`}
                    onChange={(e) => handleSelectChange(e)}
                  >
                    <option value="" className="bg-[#0B1120]">
                      Please select an event
                    </option>
                    {isLoading ? (
                      <option value="" disabled className="bg-[#0B1120]">
                        Loading...
                      </option>
                    ) : (
                      serachevents?.map((opt, idx) => (
                        <option key={idx} value={opt?.id} className="bg-[#0B1120]">
                          {opt?.name}
                        </option>
                      ))
                    )}
                  </select>
                  {isLoading && (
                    <div className="mt-2 flex justify-center">
                      <Spinner />
                    </div>
                  )}
                </div>
              )}

              <div>
                <label htmlFor="trending-paragraph" className={labelClass}>
                  Carousal Paragraph
                </label>
                <input
                  id="trending-paragraph"
                  value={Paragraph}
                  onChange={(e) => setParagraph(e.target.value)}
                  type="text"
                  placeholder="Please Enter Paragraph"
                  className={inputClass}
                />
              </div>

              <div>
                <label htmlFor="trending-image" className={labelClass}>
                  Carousal Image
                </label>
                <input
                  id="trending-image"
                  onChange={uploadImageChange}
                  type="file"
                  accept="image/*"
                  className={`${inputClass} file:mr-4 file:py-1 file:px-3 file:rounded-lg file:border-0 file:text-[12px] file:bg-[#E52324]/20 file:text-[#E52324]`}
                />
                {image && (
                  <p className="mt-2 text-[11px] text-white/35">
                    Selected: {image.name}
                  </p>
                )}
              </div>

              <button
                type="button"
                className="w-full py-3 rounded-xl bg-[#E52324] hover:bg-[#d11f20] text-white text-[14px] transition-colors"
                style={{ fontWeight: 700 }}
                onClick={createeventFunction}
              >
                Create
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default TrendingEvent;
